// No-op debug module for production builds

module.exports = () => () => {
  /* ignore logging */
};
